// eslint-disable-next-line import/prefer-default-export, no-shadow
  export enum ModelsActionTypes {
    GET_MODELS = 'GET_MODELS',
  }
  